import React, { useState, useEffect, useContext } from "react";
import { TextField, IconButton, InputAdornment } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const FormInputs = ({
  label,
  placeholder,
  value,
  onChange,
  type,
  required,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const clickField = (value) => {
    !value && required && setError("Empty.");
  };

  const blurField = () => {
    setError("");
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <label style={styles.field}>
      <span style={styles.name}>{label}</span>
      <TextField
        onClick={(event) => clickField(event.target.value)}
        onBlur={() => blurField()}
        style={styles.formItem__textField}
        onChange={(event) => {
          const { value } = event.target;
          onChange(value);
        }}
        InputProps={
          type == "password"
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {}
        }
        type={type == "password" && showPassword ? "text" : type}
        value={value}
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        margin="normal"
        autoComplete="new-password"
        error={error}
      />
    </label>
  );
};

const styles = {
  field: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "baseline",
  },
  name: {
    width: "260px",
    color: "#808285",
    fontWeight: "bold",
    textAlign: "left",
  },
  formItem__textField: {
    margin: "0 10px 10px 0",
    width: "calc(100% - 150px) !important",
  },
};

export default FormInputs;
